import * as angular from 'angular';
import { ComponentDefinition, Dashboard } from '../../../models';
import { IAuthorizationService } from '../../../services';
import { Roles } from '../../../common';

class DocumentationDashboardStateController implements angular.IComponentController {
    category: string;
    dashboards: Dashboard[];
    hasEditRole: boolean;
    readonly isLoading: boolean;

    static $inject = ['authorizationService'];

    constructor(
        private _authorizationService: IAuthorizationService) {
            this.hasEditRole = this._authorizationService.isInRoles(Roles.editDocumentationRoles);
    }

    $onInit() {
        this.loadItem();
    }

    loadItem(): any {
    }

    save(): void {
    }
}

export const wtDocumentationDashboardState: ComponentDefinition = {
    componentId: 'wtDocumentationDashboardState',
    controller: DocumentationDashboardStateController,
    controllerAs: 'vm',
    template: require('./documentationDashboardState.component.html'),
    bindings: {
        isLoading: '<',
        hasEditRole: '<'
    }
};
